var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.formattedMoney)?_c('vx-no-info-dash'):_c('span',[_vm._v(_vm._s(_vm.formattedMoney))])}
var staticRenderFns = []

export { render, staticRenderFns }